import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Date from "../../../../Core/Fields/Floating/Date";
import { useGetCountryListQuery, useGetCurrencyListQuery, useGetHolidayListQuery, useGetLetterHeadListQuery, useGetParentCompanyListQuery } from "../../../../store/api/companyapi";
import { MdTextDecrease } from "react-icons/md";

const GeneralDetails = ({ formData, handleChange, errors }) => {
  const { data:currency, isLoading:currencyLoader } = useGetCurrencyListQuery(); 
  const { data:country, isLoading:countryLoader } = useGetCountryListQuery(); 
  const { data:letterhead, isLoading:letterheadLoader } = useGetLetterHeadListQuery(); 
  const { data:holiday, isLoading:holidayLoader } = useGetHolidayListQuery(); 
  const { data:parentCompany, isLoading:parentCompanyLoader } = useGetParentCompanyListQuery({"doctype":"Company","fields":`["name"]`,"filters":`[["Company","is_group","=",1]]`,"view":"List"});  // ,"order_by":`tabCompany.parent_company+asc`
  let formattedCompanyData = [];
    if (Array.isArray(parentCompany?.message?.values) && Array.isArray(parentCompany?.message?.keys)) {
    formattedCompanyData = [...parentCompany.message.values].reverse().map(valueArr => {
        return parentCompany.message.keys.reduce((acc, key, index) => {
            acc[key] = valueArr[index];
            return acc;
        }, {});
    });
    };

    

  const gstRates = [
  { name: "0.0" },
  { name: "0.25" },
  { name: "1.0" },
  { name: "3.0" },
  { name: "1.5" },
  { name: "5.0" },
  { name: "6.0" },
  { name: "7.5" },
  { name: "0.1" },
  { name: "12.0" },
  { name: "18.0" },
  { name: "28.0" }
];

  return (
  countryLoader || currencyLoader || holidayLoader || letterheadLoader ? "" : <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
      <div className="col-12">
        <p className="boxLabel m-0">General Details</p>
      </div>
      
      {/* Row 1 */}
      <div className="col-3">
        <div className="mb-3">
          <Input
            id="companyName"
            label="Company Name"
            style={{ height: "30px", border: errors.companyName ? "1px solid red" : "" }}
            value={formData.companyName}
            onChange={(e) => handleChange('companyName', e.target.value)}
          />
        </div>
      </div>
      
      <div className="col-3">
        <div className="mb-3">
          <Input
            id="abbreviation"
            label="Abbreviation"
            style={{ height: "30px", border: errors.abbreviation ? "1px solid red" : "" }}
            value={formData.abbreviation}
            onChange={(e) => handleChange('abbreviation', e.target.value)}
          />
        </div>
      </div>
      
      <div className="col-3">
        <div className={errors.defaultCurrency ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={currency.data}
            label="Default Currency"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formData.defaultCurrency}
            onChange={(val) => handleChange('defaultCurrency', val)}
          />
        </div>
      </div>
      
      <div className="col-3">
        <div className="mb-3">
          <SelectSearch
            list={country.data}
            label="Country"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formData.country}
            onChange={(val) => handleChange('country', val)}
          />
        </div>
      </div>

      {/* Row 2 */}
      <div className="col-4">
        <div className="mb-3">
          <SelectSearch
            list={gstRates}
            label="Default GST Rate"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formData.defaultGSTRate}
            onChange={(val) => handleChange('defaultGSTRate', val)}
          />
          <p className="m-0" style={{fontSize:'10px',paddingLeft:'3px'}} >Sales / Purchase Taxes and Charges Template will be created based on this GST Rate</p>
        </div>
      </div>

      <div className="col-4">
        <div className="mb-3">
          <SelectSearch
            list={holiday.data}
            label="Default Holiday List"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formData.defaultHolidayList}
            onChange={(val) => handleChange('defaultHolidayList', val)}
          />
        </div>
      </div>

      <div className="col-4">
        <div className="mb-3">
          <SelectSearch
            list={letterhead.data}
            label="Default Letter Head"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formData.defaultLetterHead}
            onChange={(val) => handleChange('defaultLetterHead', val)}
          />
        </div>
      </div>

      {/* Row 3 */}
      <div className="col-3">
        <div className="mb-3">
          <Input
            id="domain"
            label="Domain"
            style={{ height: "30px" }}
            value={formData.domain}
            onChange={(e) => handleChange('domain', e.target.value)}
          />
        </div>
      </div>

      <div className="col-3">
        <div className="mb-3">
          <Input
            id="taxID"
            label="Tax ID"
            style={{ height: "30px" }}
            value={formData.taxID}
            onChange={(e) => handleChange('taxID', e.target.value)}
          />
        </div>
      </div>

      <div className="col-3">
        <div className="mb-3">
          <Date
            id="dateOfEstablishment"
            label="Date of Establishment"
            value={formData.dateOfEstablishment}
            onChange={(val) => handleChange('dateOfEstablishment', val.target.value)}
          />
          
        </div>
      </div>

      <div className="col-3">
        <div className="mb-3">
          <SelectSearch
            list={formattedCompanyData}
            label="Parent Company"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formData.parentCompany}
            onChange={(val) => handleChange('parentCompany', val)}
          />
        </div>
      </div>


      <div className="col-3">
        <div className="mb-3 ">
          <input type="checkbox" checked={formData.isgroup} name="IsGroup" className="form-check-input" style={{backgroundColor:'#FFFFF',borderColor:'#270b79'}} onChange={(val) => handleChange('isgroup', !formData.isgroup)} id="" />
          <label htmlFor="IsGroup" style={{fontSize:'0.9rem',position:'relative',top:'-1px',paddingLeft:'5px'}}>Is Group</label>
        </div>
      </div>
    </div>
  );
};

export default GeneralDetails;
